import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";

export class BonusDoors extends PIXI.Container implements StageLayer {
    private _doorSpine: PIXI.spine.Spine;


    constructor() {
        super();
        this.name = "DoorsView";
        this.init();
    }


    public onResize(): void {
        if (NolimitApplication.isLandscape) {
            this._doorSpine.scale.set(1, 1);
        } else {
            this._doorSpine.scale.set(0.75, 0.75);
        }
    }


    public transitionDownwardsNew(): gsap.core.Timeline {
        const downTL: gsap.core.Timeline = gsap.timeline();
        downTL.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BONUS_DOOR_CHANGE_LEVEL);
        }, 0);
        return downTL;
    }


    public closeGate(nextMode: string): gsap.core.Timeline {
        const closeTl: gsap.core.Timeline = gsap.timeline();
        closeTl.add(() => {
            this._doorSpine.visible = true;
        }, 0);
        closeTl.add(SpineGSAPWrapper.createTimelineForAnimation(this._doorSpine, 0, "close", false), 0);
        closeTl.add(SpineGSAPWrapper.createTimelineForAnimation(this._doorSpine, 0, "doorIdle", false));
        closeTl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BONUS_DOOR_CLOSE);
        }, 0);
        return closeTl;
    }


    public openGate(nextMode: string): gsap.core.Timeline {
        const openTl: gsap.core.Timeline = gsap.timeline();
        openTl.add(() => {
            this._doorSpine.visible = true;
            this._doorSpine.alpha = 1;
            this._doorSpine.y = 388;
        }, 0);
        openTl.add(SpineGSAPWrapper.createTimelineForAnimation(this._doorSpine, 0, "open", false));
        openTl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.BONUS_DOOR_OPEN);
        }, 0);

        return openTl;
    }


    private init(): void {
        this._doorSpine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.TRANSITION_DOORS));
        this._doorSpine.position.set(358, 388);
        this._doorSpine.name = "doors";
        this._doorSpine.visible = false;
        this.addChild(this._doorSpine);
        this.onResize();
    }

}